export const LOADING_DATA = 'LOADING_DATA';
export const SET_DATA = 'SET_DATA';
export const ERROR = 'ERROR';

export default (state, action) => {
  switch (action.type) {
    case LOADING_DATA:
      return {
        ...state,
        metadata: {
          ...state.metadata,
          loading: true,
        },
        assets: {
          ...state.assets,
          loading: true,
        },
        config: {
          ...state.config,
          loading: true,
        },
      };
    case ERROR:
      return {
        ...state,
        metadata: {
          ...state.metadata,
          loading: false,
          error: true,
        },
        assets: {
          ...state.assets,
          loading: false,
          error: true,
        },
        config: {
          ...state.config,
          loading: false,
          error: true,
        },
      };
    case SET_DATA:
      return {
        ...state,
        region: action.payload.region,
        metadata: {
          model: action.payload.metadata,
          loading: false,
          error: false,
        },
        assets: {
          model: action.payload.assets,
          loading: false,
          error: false,
        },
        config: {
          responseConfig: action.payload.responseConfig,
          loading: false,
          error: false,
        },
      };
    default:
      return state;
  }
};
